<script>
import twSelectFieldMixin from '@/mixins/twSelectFieldMixin.js'
import TwLoadingSpinnerMini from '@/components/generic/tw-loading-spinner-mini.vue'

export default {
  name: 'TwSelect',
  components: { TwLoadingSpinnerMini },
  mixins: [twSelectFieldMixin],
}
</script>

<template>
  <div class="grid grid-cols-10">
    <div :class="[{'col-span-9':loading}, {'col-span-10':!loading}]">
      <fieldset>
        <label v-if="label" class="form-label"> {{ label }} </label>
        <select :id="id" v-model="SelectedIndex" :disabled="loading" :required="required" :name="id" :autocomplete="id" class="block w-full rounded-md border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400 placeholder:text-gray-400 focus:ring-1 focus:ring-inset text-sm focus:ring-gray-800  sm:leading-6">
          <option v-if="placeholder" :value="null" disabled selected>
            {{ placeholder }}
          </option>
          <option :value="null" />
          <slot>
            <option v-for="(option, index) in options" :key="'tw-key-option-' + index + '-' + id" :value="index">
              {{ labelKey? option[labelKey]: option }}
            </option>
          </slot>
        </select>
      </fieldset>
    </div>
    <div v-if="loading" class="col-span-1 flex flex-col items-center justify-center pt-5">
      <tw-loading-spinner-mini v-if="loading" />
    </div>
  </div>
</template>

<style scoped>

</style>
